import storage from 'store'
const VERSION = require('../../../package.json').version
const BASE_URL = process.env.BASE_URL.slice(1, -1).replace(/app$/, '')
const keyName = `LeelenAfterSale${BASE_URL}${VERSION}`

console.log('VERSION:', VERSION)
storage.each(function (value, key) {
  if (key.includes(`LeelenAfterSale${BASE_URL}`) && key !== keyName) {
    storage.remove(key)
  }
})
export default store => {
  const localStore = storage.get(keyName)
  if (localStore) {
    // 重置加载状态
    store.replaceState(localStore)
  }
  store.subscribe((mutation, state) => {
    storage.set(keyName, state)
  })
}
